import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';
import {selectRecentlyViewedAccounts} from 'src/hooks/recently-viewed/services/recently-viewed-slice';
import {getRecentlyViewedAccounts} from 'src/openapi/admin/apis/GetRecentlyViewedAccountsApi';
import {useAppDispatch} from 'src/store/hooks';

import {FormSection} from '@pb/kit-component-form-section';
import {Scroll} from '@pb/kit-component-scroll';

import {
    recentlyViewedSection,
    recentlyViewedSectionRecord,
    recentlyViewedSectionRecordsList,
} from './recently-viewed-section.module.styl';


export const RecentlyViewedAccounts = () => {
    const apiDispatch = useAppDispatch();
    const recentlyViewedAccounts = useSelector(selectRecentlyViewedAccounts);

    useEffect(() => {
        apiDispatch(getRecentlyViewedAccounts());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <FormSection className={recentlyViewedSection}>
            <div className={recentlyViewedSectionRecordsList}>
                {!!recentlyViewedAccounts.length && (
                    <Scroll>
                        <ul>
                            {recentlyViewedAccounts.map(({accountId, accountName}) => (
                                <li key={accountId} className={recentlyViewedSectionRecord}>
                                    <AccountLink
                                        place="Recently Viewed Account"
                                        accountId={accountId}
                                        accountName={accountName}
                                    />
                                </li>
                            ))}
                        </ul>
                    </Scroll>
                )}
            </div>
        </FormSection>
    );
};
